// Actions
import {
  SET_EVENT_LISTENER_HAS_BEEN_ATTACHED,
  SET_GOOD_DATA_EVENT,
  SET_PLATFORM_INFO_EVENT,
  SET_FILTER_VALUE_CHANGE_EVENT,
  SET_UI_DRILL_EVENT,
  SET_DATE_RANGE,
  SET_USER_BROWSER
} from "../actionTypes/goodData.actionTypes";

// Classes
import { GoodDataReducerState } from "../classes/goodData.classes";

const initialState = new GoodDataReducerState();

export const GoodDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_EVENT_LISTENER_HAS_BEEN_ATTACHED:
      return { ...state, eventListenerHasBeenAttached: action.payload };
    case SET_GOOD_DATA_EVENT:
      return { ...state, goodDataEvent: action.payload };
    case SET_PLATFORM_INFO_EVENT:
      return { ...state, platformInfoEvent: action.payload };
    case SET_FILTER_VALUE_CHANGE_EVENT:
      return { ...state, filterValueChangeEvent: action.payload };
    case SET_UI_DRILL_EVENT:
      return { ...state, uiDrillEvent: action.payload };
    case SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };
    case SET_USER_BROWSER:
      return { ...state, userBrowser: action.payload };
    default:
      return state;
  }
};
